/**
 * @Author: brand
 * @Date: 2019-06-26 15:04
 * @Email: brandhuang@qq.com
 */
import ax from '../../axios'

/**
 * 访问轨迹
 * @param params
 */
export function websiteTrackReportAPI (params) {
    return ax({
        url: '/wlapi/report/trackReport',
        method: 'POST',
        data:params
    })
}

/**
 * 获取地址
 * @param params
 */
export function websiteGetAddrAPI (params) {
    return ax({
        url: '/wlapi/report/addrData',
        method: 'POST',
        data:params
    })
}

/**
 * 关键词统计列表
 * @param params
 */
export function keywordStatisticList (params) {
  return ax({
    url: '/wlapi/report/keywordStatisticList',
    method: 'POST',
    params
  })
}

/**
 * 访问明细列表
 * @param params
 */
export function visitDetailList (params) {
  return ax({
    url: '/wlapi/report/visitDetailList',
    method: 'POST',
    params
  })
}

/**
 * 访客明细列表
 * @param params
 */
export function visitorDetailList (params) {
  return ax({
    url: '/wlapi/report/visitorDetailList',
    method: 'POST',
    params
  })
}